import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ICarrier } from "../carrierModel";

export const getAllCarrier = createAsyncThunk(
  "Carrier/FindAllCarrier",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Carrier/FindAllCarrier`,
        {
          Carrier: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      // console.error("Error Fetching Carrier:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveCarrier = createAsyncThunk(
  "Carrier/FindAllActiveCarrier",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Carrier/FindAllActiveCarrier`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Carrier:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createCarrier = createAsyncThunk(
  "Carrier/InsertCarrier",
  async (CarrierData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Carrier/InsertCarrier`,
        CarrierData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Carrier:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateCarrier = createAsyncThunk(
  "Carrier/updateCarrier",
  async (CarrierData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Carrier/updateCarrier`,
        CarrierData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Carrier:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCarrierByID = createAsyncThunk(
  "Carrier/FindByIDCarrier",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Carrier/FindByIDCarrier`,
        { carrier_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        isactive: result.isactive === true ? 1 : 2,
        carrier_guid: result.carrier_guid,
        carrier_name: result.carrier_name,
        city_id: result.city_id,
        state_id: result.state_id,
        country_id: result.country_id,
        contact_person: result.contact_person,
        mobile_number: result.mobile_number,
        carrier_type: result.carrier_type,
        address: result.address,
      } as ICarrier;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Carrier:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const carrierActiveInactive = createAsyncThunk(
  "Carrier/ActiveInActiveCarrier",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Carrier/ActiveInActiveCarrier`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Carrier:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteCarrier = createAsyncThunk(
  "Carrier/DeleteCarrier",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Carrier/DeleteCarrier`,
        { carrier_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Carrier:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
